var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.934,
    height: 33.239,
    viewBox: "0 0 35.934 33.239",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#4bc0c0;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.026,6a3.165,3.165,0,0,0-3.144,3.144V11.39H7.144A3.165,3.165,0,0,0,4,14.534v21.56a3.165,3.165,0,0,0,3.144,3.144H36.789a3.165,3.165,0,0,0,3.144-3.144V14.534a3.165,3.165,0,0,0-3.144-3.144H30.052V9.144A3.165,3.165,0,0,0,26.908,6Zm0,2.7h9.882a.429.429,0,0,1,.449.449V11.39H16.577V9.144A.429.429,0,0,1,17.026,8.7ZM7.144,18.24H36.789a.429.429,0,0,1,.449.449v7.973H24.662v-.449a1.348,1.348,0,0,0-1.348-1.348h-2.7a1.348,1.348,0,0,0-1.348,1.348v.449H6.7V18.689A.429.429,0,0,1,7.144,18.24ZM6.7,29.357H19.272v1.834a1.348,1.348,0,0,0,1.348,1.348h2.7a1.348,1.348,0,0,0,1.348-1.348V29.357H37.239v6.738a.429.429,0,0,1-.449.449H7.144a.429.429,0,0,1-.449-.449Z",
    transform: "translate(-4 -6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.42030a50e785b67e466ebda8254a1ea6.svg";
export { ForwardRef as ReactComponent };